(function () {
  'use strict';

  var gallery = document.getElementById('fm-clubs-showcase');
  if (!gallery) return;

  var dataEl = document.getElementById('fm-clubs-showcase-data');
  if (!dataEl) return;

  var pairs;
  try {
    pairs = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!pairs || pairs.length < 2) return;

  var front = document.getElementById('fm-clubs-pair-front');
  var back = document.getElementById('fm-clubs-pair-back');
  var caption = document.getElementById('fm-clubs-showcase-caption');
  var progress = document.getElementById('fm-clubs-showcase-progress');
  var dots = gallery.querySelectorAll('.foremark-clubs-showcase-dot');
  var prevBtn = gallery.querySelector('.foremark-clubs-showcase-arrow--prev');
  var nextBtn = gallery.querySelector('.foremark-clubs-showcase-arrow--next');
  var current = 0;
  var timer = null;
  var AUTO_MS = 5000;

  function applyPair(layer, idx) {
    var pair = pairs[idx];
    if (!pair) return;
    var leftImg = layer.querySelector('.foremark-clubs-showcase-cell--left img');
    var rightImg = layer.querySelector('.foremark-clubs-showcase-cell--right img');
    if (leftImg) {
      leftImg.src = pair.left;
      leftImg.alt = pair.leftAlt || '';
    }
    if (rightImg) {
      rightImg.src = pair.right;
      rightImg.alt = pair.rightAlt || '';
    }
  }

  function goTo(idx) {
    if (idx === current || idx < 0 || idx >= pairs.length || !front || !back) return;

    applyPair(back, idx);
    back.style.opacity = '0';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        front.style.opacity = '0';
        back.style.opacity = '1';
        setTimeout(function () {
          applyPair(front, idx);
          front.style.transition = 'none';
          front.style.opacity = '1';
          back.style.transition = 'none';
          back.style.opacity = '0';
          setTimeout(function () {
            front.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
            back.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
          }, 50);
        }, 1150);
      });
    });

    dots[current].classList.remove('active');
    dots[current].setAttribute('aria-selected', 'false');
    current = idx;
    dots[current].classList.add('active');
    dots[current].setAttribute('aria-selected', 'true');
    if (caption) caption.textContent = pairs[current].caption || '';
    restartProgress();
  }

  function next() {
    goTo((current + 1) % pairs.length);
  }

  function prev() {
    goTo((current - 1 + pairs.length) % pairs.length);
  }

  function restartProgress() {
    if (!progress) return;
    progress.style.transition = 'none';
    progress.style.width = '0%';
    clearTimeout(timer);
    void progress.offsetWidth;
    progress.classList.add('animating');
    progress.style.width = '100%';
    timer = setTimeout(next, AUTO_MS);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var idx = parseInt(dot.getAttribute('data-clubs-index'), 10);
      if (!isNaN(idx)) goTo(idx);
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  gallery.addEventListener('mouseenter', function () {
    clearTimeout(timer);
    if (progress) progress.style.transition = 'none';
  });
  gallery.addEventListener('mouseleave', restartProgress);

  front.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
  back.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
  applyPair(front, 0);
  applyPair(back, 1);
  if (caption) caption.textContent = pairs[0].caption || '';
  restartProgress();
})();
